import axios from 'axios'
import store from '@/store'
import router from '@/router' // 导入router实例

import { Message } from 'element-ui'
import { TOKEN_KEY } from '@/constants'
import { showLoading, hideLoading } from '@/utils/loading'

// 创建axios实例
const service = axios.create({
  baseURL: (process.env.NODE_ENV === 'development' && window.location.href.indexOf('localhost') !== -1) ? '/api' : process.env.VUE_APP_BASE_API,
  timeout: 30000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 显示loading
    showLoading()
    
    const token = localStorage.getItem(TOKEN_KEY)
    if (token) {
      config.headers.Authorization = token // 请求头部添加token
      config.headers.Authorization_Resource = token // 请求头部添加token
      config.headers.token = token
    }
    return config
  },
  error => {
    // 隐藏loading
    hideLoading()
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(  
  response => {
    // 隐藏loading
    hideLoading()
    
    const res = response.data
    
    // 检查是否是我们期望的后端响应格式
    if (res.hasOwnProperty('state')) {
      // 这是后端返回的标准格式
      if (res.state !== 'success') {
        // 如果是特定错误码 0101015，则执行登出操作并跳转到首页
        if (res.errCode === '0101015') {
          Message.error('登录已过期，请重新登录')
          store.dispatch('logout').then(() => {
            // 登出完成后跳转到首页
            router.push('/')
          })
          return Promise.reject(new Error(res.errMsg || '请求失败'))
        }
        Message.error(res.errMsg || '请求失败')
        return Promise.reject(new Error(res.errMsg || '请求失败'))
      }
      return res // 返回后端响应的数据
    }
    
    // 对于非后端标准格式的响应，直接返回
    return response
  },
  error => {
    // 隐藏loading
    hideLoading()
    console.error('响应错误:', error)
    Message.error(error.message || '网络异常，请稍后重试')
    return Promise.reject(error)
  }
)

export default {
  fPost(url, data, options = {}) {
    return service({
      method: 'post',
      url,
      data: data,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        ...options.headers
      }
    })
  },

  fGet(url, params) {
    return service({
      method: 'get',
      url,
      params
    })
  },

  downloadFile(url, params) {
    return service({
      method: 'get',
      url,
      params,
      responseType: 'blob' // 设置响应类型为blob，用于文件下载
    })
  }
}